<div class="material-page">
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
      <div *ngIf="item" class="left mdc-layout-grid__cell mdc-layout-grid__cell--span-2-desktop mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-4-phone">
        <compact-listing-image [item]="item!"></compact-listing-image>
      </div>
      <div *ngIf="item" class="left mdc-layout-grid__cell mdc-layout-grid__cell--span-7-desktop mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-4-phone">
        <compact-listing-description [item]="item!"></compact-listing-description>
      </div>
      <div *ngIf="item" class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
        <compact-listing-buttons [item]="item!" [editNextPage]="router.url"/>
      </div>
      <div class="left gallery-or-icon mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <mat-divider></mat-divider>
      </div>  
      <div class="left gallery-or-icon mdc-layout-grid__cell mdc-layout-grid__cell--span-8">
        <chat [chatId]="chatId!"></chat>
      </div>
    </div>
  </div>
</div>